import React from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from '../LanguageSelector';

export function LayoutFooter(props) {
    const { t } = useTranslation("translation", { useSuspense: false });

    return (
        <footer>
            <div className="footer-box-left" />
            <div className="footer-box-center">
                <span className="text-muted">
                    {t("Master_Sec0_metaTitle_MasterFooter")} <strong>{t("Master_Sec0_metaTitle_MasterTitle")}</strong>. <strong>{t("Master_Sec0_metaTitle_MasterVersion")}</strong>{props.VersionSistema}
                </span>
            </div>
            <div className="footer-box-right">
                <LanguageSelector
                    selectedLanguage={props.userLanguage}
                    changeLanguage={props.changeLanguage}
                />
            </div>
        </footer>
    );
}


// WEBPACK FOOTER //
// ./src/components/LayoutComponents/LayoutFooter.js